import { VivaError } from '@viva/core';
import type { CatalogApi, Endpoint } from '@viva/data';
import { CatalogClient, RpcClient } from '@viva/data';
import type { RelayConfig } from './network';
import { setRelay } from './network';
// `?worker` lets Vite serve a module worker in development and emit a
// classic (IIFE) worker in builds, which older TV engines require.
import CatalogWorker from './catalog.worker?worker';

let catalogWorker: Worker | null = null;

/** Routes provider requests of the page and the catalog worker through the streaming relay. */
export function configureRelay(next: RelayConfig | null): void {
  setRelay(next);
  catalogWorker?.postMessage({ type: 'viva-relay', relay: next });
}

/** Starts the catalog worker and returns a typed client for it. */
export function startCatalog(): CatalogApi {
  const worker = new CatalogWorker();
  catalogWorker = worker;
  const rpc = new RpcClient(worker as unknown as Endpoint);
  worker.addEventListener('error', (event) => {
    console.error('Catalog worker crashed', event.message);
    rpc.failAll(new VivaError('storage', 'The catalog stopped unexpectedly. Restart the app.', { detail: 'catalog worker crashed' }));
  });
  return new CatalogClient(rpc);
}
